<template>
  <DbsLinkButton label="使い方" url="https://www.emot.jp/howtouseb.html" />
</template>

<script>
export default {
  name: "DbsHowToUseLinkButton",
};
</script>